import {
  Visibility,
  Provider,
  CreatedFrom,
  Status,
  PlaybackStatus,
  OnFireLanguage,
  TransmissionInfo
} from 'modules/transmission/types'

export const EMPTY_TRANSMISSION_INFO: TransmissionInfo = {
  code: '',
  name: '',
  conversationId: '',
  description: '',
  visibility: Visibility.DEFAULT,
  provider: Provider.HOTMART,
  completed: false,
  liveStartAt: '',
  zoneId: '',
  largeThumbnailLink: '',
  smallThumbnailLink: '',
  enableVodPlayback: false,
  maxDurationMinutes: 0,
  maxParticipants: 0,
  createdFrom: CreatedFrom.WEBINAR,
  status: Status.CREATED,
  playbackStatus: PlaybackStatus.INACTIVE,
  embedUrl: '',
  playerJwt: '',
  applicationCode: '',
  userCode: ''
}

export const ON_FIRE_LANGUAGE_LABEL: {[language in OnFireLanguage]: string } = {
  [OnFireLanguage.PORTUGUES]: 'Português (Brasil)',
  [OnFireLanguage.ENGLISH]: 'English',
  [OnFireLanguage.SPANISH]: 'Spanish',
  [OnFireLanguage.LIBRAS]: 'Libras'
}
